export default __webpack_public_path__ + "static/media/red-tiger.ad1d4d10.png";